// extracted by mini-css-extract-plugin
module.exports = {"row1":"HomeInfoRows_row1_22VUm","row2":"HomeInfoRows_row2_3AplQ"};